module.exports = __webpack_public_path__ + "12e2ed7a180e601bff44253d4c7062ad.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/ExtraBold/OpenSans-ExtraBold.woff?v=1.1.0
// module id = 1014
// module chunks = 0